import React, { useState } from 'react';
import '../styles/about-mnh.css';
import '../styles/gallery.css';
import { PhoneCall, House, Mail } from 'lucide-react';

const tabData = {
  Infrastructure: {
    title: 'Infrastructure',
    content: 'Our infrastructure includes patient wards, diagnostic areas, operation theatres, and supporting medical spaces. These facilities are designed to ensure a safe, hygienic, and well-managed environment for both routine care and emergency services.',
    images: [
      {
        src: require('../assets/img/gallery/infra/infra-1.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-2.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-3.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-4.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-5.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-6.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-7.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-8.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-9.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-10.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-11.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/infra/infra-12.png'),
        title: ' '
      }
    ]
  },
  'Involvement': {
    title: 'Social Involvement',
    content: 'Our diagnostic and nursing home is committed not only to clinical excellence but also to meaningful participation in community health and welfare initiatives. Through a series of social, preventive, and awareness programs, we strive to bring quality healthcare within the reach of every individual—especially those who need it the most.',
    images: [
      {
        src: require('../assets/img/gallery/social/social-1.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-2.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-3.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-4.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-5.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-6.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-7.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-8.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-9.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-10.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-11.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/social/social-12.png'),
        title: ' '
      }
    ]
  },
  'Treatment': {
    title: 'Treatment',
    content: 'Our diagnostic and nursing home offers a comprehensive range of clinical and surgical treatments supported by modern technology, skilled specialists, and evidence-based protocols. From routine procedures to complex surgeries, our focus remains consistent: safe outcomes, precision in diagnosis, and patient-centered care.',
    images:[
      {
        src: require('../assets/img/gallery/treatment/treat-1.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-2.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-3.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-4.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-5.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-6.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-7.png'),
        title: ' '
      },
      {
        src: require('../assets/img/gallery/treatment/treat-8.png'),
        title: ' '
      },
    ]
  }
};

// Tab component for Gallery section
function GalleryTabs() {
    const [activeTab, setActiveTab] = useState('Infrastructure');

    const tabs = Object.keys(tabData);

    return (
      <div className="gallery-tabs-container">
        <div className="gallery-tabs">
          {tabs.map(tab => (
            <div
              key={tab}
              className={`gallery-tab${activeTab === tab ? ' active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>
        <div className="gallery-tab-content">
          <div>{tabData[activeTab].title}</div>
          <div>{tabData[activeTab].content}</div>
          <div className="gallery-tab-row" style={{ marginTop: '20px' }}>
            {/* Render images for tabs that have an images array */}
            {tabData[activeTab].images && (
              <div className='displayDiv'>
                {tabData[activeTab].images.map((img, idx) => (
                  <div
                    key={idx}
                    className='imgDiv'
                  >
                    <img
                      src={img.src}
                      alt={img.title}
                      className='img-class'
                    />
                    <div className='img-title'>
                      {img.title}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

function Gallery() {
  
  
  return (
    <>
      <div className="gallery-container">
        <div className="gallery-image-wrapper">
          <img
            src={require("../assets/img/gallary.png")}
            alt="Gallery"
            className="gallery-image"
          />
          <div className="gallery-overlay-title">
            Facilities Designed for Safe Patient Care
            <p style={{fontWeight:'normal', fontSize:'35px',lineHeight:'1',color:'#FFFFFF', textAlign:'center'}}>Well-equipped infrastructure supporting accurate diagnosis and treatment.</p>
          </div>
        </div>
      </div>
      <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff" />
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
      <section className='tabGallerys'>
        <GalleryTabs />
      </section>
    </>
  );
}

export default Gallery;
